import React, { useState, useMemo } from 'react'
import { KTSVG } from '../../../_metronic/helpers'

type TooltipPosition = 'top' | 'bottom' | 'left' | 'right'
type TooltipTheme = 'light' | 'dark'

interface GenericTooltipProps {
    text: string
    maxLength?: number
    position?: TooltipPosition
    iconPath?: string
    theme?: TooltipTheme
    className?: string
    maxWidth?: number | string
}

const TooltipMaxLength: React.FC<GenericTooltipProps> = ({
    text,
    maxLength = 30,
    position = 'top',
    iconPath,
    theme = 'light',
    className,
    maxWidth = 250,
}) => {
    const [open, setOpen] = useState(false)

    const truncatedText = useMemo(() => {
        if (!text) return ''
        if (text.length <= maxLength) return text
        return `${text.substring(0, maxLength)}...`
    }, [text, maxLength])

    return (
        <div
            className="generic-tooltip-wrapper position-relative d-inline-block"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            {/* Trigger */}
            <span
                className={`d-inline-flex align-items-center gap-1 ${className ?? ''}`}
            >
                {truncatedText}
                {iconPath && <KTSVG path={iconPath} />}
            </span>

            {/* Tooltip */}
            {open && text.length > maxLength && (
                <div className={`generic-tooltip-card generic-tooltip-${position} generic-tooltip-${theme}`}
                    style={{
                        width: `${maxWidth}px`,
                        minWidth: `${maxWidth}px`,
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                    }}>
                    {text}
                </div>
            )}
        </div>
    )
}

export default TooltipMaxLength